define('drops/list/list',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/eventSource',
    'when',
    'lq/windowSize',
    'lq/nestingContext',
    'lq/onlongpress',
    'lq/dropSortable',
    'lq/required',
    './cqListTools'
], function ($, _, Drop, Style, util, EventSource, when, windowSize, NestingContext, OnLongPress, dropSortable, Required, cqList) {
    'use strict';

    var defaultPageSize = 128;

    var positioningProps = ["float", "height", "left", "top", "marginLeft", "marginTop", 'marginRight', 'marginBottom', "paddingLeft", "paddingTop"];

    var defaults = {
        data: {
            size: { x: 200, y: 150 },
            childPositionX: 10,
            childPositionY: 10,
            childSizeX: 100,
            childSizeY: 50,
            layout: 'Vertical',
            selectionMode: 'single',
            selectionBehavior: 'ctrl+leftclick',
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            pagingEnabled: false,
            pageSize: defaultPageSize,
            infiniteScroll: false,
            stopAutoLoadPages: 10,
            onlyLoadFirstPage: false,
            groupByColumns: [],
            listItemAlignment: 'left',
            isParentIdEnabled: false,
            isAspectRatioEnabled: false,
            ratioWidth: 3,
            ratioHeight: 3,
            longPressDelay: 1000,
            eventThreshold: 90,
            stayThreshold: 60,
            reverseScrolling: false,
            listItemAutoSize: false,
            horAlignDirection: 'Left',
            verAlignDirection: 'Top',
            enableSorting: false,
            handlerDropName: '',
            enableScrollingWithSorting: true,
            animationTime: 300,
            scrollSensitivity: 100,
            scrollSpeed: 15,
            useCustomDragPreview: false,
        }
    };

    var preloadDistance = 150; // px

    var xDown = null;
    var yDown = null;
    var initialPos = null;

    var mouseDown = false;

    function List(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        EventSource.call(this, [
            'PageOpened'
        ]);

        var self = this;

        self.data.eventing = util.convertListOfKeyValuesToObject(self.data.eventing);

        self.initializeTemplates();

        self.scrollTop = 0;
        self.scrollLeft = 0;
        self.rendered = false;
        self.loading = false;
        self.rendering = false;
        self.afterRendering = [];
        self.loadedPagesForward = 0;
        self.loadedPagesBackward = 0;
        self.startPage = null;

        if (self.data.reverseScrolling) {
            self.loadedPagesBackward++;
        } else {
            self.loadedPagesForward++;
        }

        self.groupingLoss = 0;
        self.queuedData = null;
        self.loadedAllData = false;
        self.newItems = 0;
        self.$element
            .addClass('boxToBorderSize list-drop')
            .css({
                whiteSpace: 'pre-wrap'
            });
        self.$list = $('<div />')
            .attr('tabindex', '-1') // needed for the focus() call
            .css({
                outline: 'none', // hide outline on focus

                // we're using 'display: inline-block' for positioning of the list items, but this will add an extra
                // vertical marging between the items unless we set 'font-size' to '0'
                fontSize: 0,
                borderRadius: 'inherit'
            })
            .appendTo(self.$element);


        this.$scrollableElement = self.$list;

        if (this.hasInfiniteScrollEnabled()) {
            this.events(windowSize,
                {
                    'Changed': _.throttle(this.checkScrollAndLoadNextPageIfNeeded.bind(this), 50)
                });
        }

        Style.renderStyles(self);

        // block touch events when we're inside a carousel and a scrollbar is visible
        self.$list.on('touchstart MSPointerDown pointerdown', function (e) {
            var el = self.$list.get(0);
            if (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth)
                e.stopPropagation();
        });

        if (this.data.layout === 'Horizontal')
            this.$element.css('white-space', 'nowrap');

        this.subscribeEventHandler($(window), 'resize', function () {
            self.setWidthOfListItems();
            self.updateAlignContainerResize();
        });
        self.allowSwipe = true;

        if (this.designData && (this.designData.hasInitialDynamicText || this.designData.hasInitialModalAction)) {
            this.data.childSizeX = this.data.hasInitialDynamicText ? 250 : 280;
            this.data.childSizeY = 40;
            this.data.childPositionX = 5;
            this.data.childPositionY = 5;
            delete this.designData.hasInitialDynamicText;
            delete this.designData.hasInitialModalAction;
        }

        this.isInAList = this.isInAListFunc();
    };

    Drop.extend(List);

    List.typeName = 'List';

    List.prototype.setWidthOfListItems = function () {
        if (this.data.layout !== 'Continuous' || !this.data.listItemAutoSize) {
            return;
        }
        var listWidth = $(this.$element.children().first()).width() - this.data.childPositionX;
        var width = this.data.childSizeX;
        var max = width + this.data.childPositionX;

        if (this.pool.length * max > listWidth) {
            var columns = Math.floor(listWidth / max);
            width = (listWidth / columns) - this.data.childPositionX;

            if (width > (max - this.data.childPositionX)) {
                width = listWidth / (columns + 1) - this.data.childPositionX;
            }
        }

        _.each(this.pool, function (drop) {
            drop.$element.css('width', width + 'px');
        });
    };

    List.prototype.decorateQueryParams = function (params) {
        if (!this.data.pagingEnabled) return;

        if (this.keepPagingInformation()) {
            params.pageSize = this.data.pageSize * this.loadedPagesForward;
        } else {
            params.pageSize = this.data.pageSize;
        }

        params.doNotExecuteCountQuery = this.data.infiniteScroll;
        params.page = 0;

        if (this.data.configureStartPageEnabled && this.data.startAtItemIdParameter) {
            this.focusStartPageElement = true;
            params.findRowByItemId = this.data.startAtItemIdParameter;
        }
    };

    List.prototype.unsubscribeEventHandlers = function () {
        if (this.datasourceListenerId) {
            this.piping.datasources
                .unregisterDatasourceListener(this.datasourceListenerId);
        }
        this.nestingContext = null;
    };

    List.prototype.isInAListFunc = function () {
        var listItem = this.getFirstParentOfType('ListItem');
        return !listItem;
    };

    List.prototype.preRender = function () {
        var self = this;

        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);

        if (!this.data.useParentGroupData)
            this.datasourceListenerId = this.piping.datasources.registerDatasourceListener(
                this.data.dataSource,
                function (data, isUpdate) {
                    return self.setData(data, isUpdate);
                },
                function (params) {
                    // TODO: save scrolltop before rerendering and not before sending request
                    setTimeout(function () {
                        //async, no need to slow down sending a request for result
                        self.scrollTop = self.$scrollableElement.scrollTop();
                        self.scrollLeft = self.$scrollableElement.scrollLeft();
                    }, 0);

                    self.decorateQueryParams(params);
                },
                this.deleteItem.bind(this)
            );

        this.nestingContext = new NestingContext(this.piping);

        if (this.data.isParentIdEnabled) {
            var nestingContext = this.getNestingContext()
            if (nestingContext) {
                nestingContext.addDataSource(this.data.dataSource);
            }
        }

        this.applyPosition();

        this.relativePositioned = this.data.autoHeight || this.makesItGrow();

        if (this.relativePositioned) {
            if (this.data.layout === 'Horizontal') {
                this.$list
                    .css({
                        overflowX: 'auto',
                        overflowY: 'hidden'
                    });
            }
            this.$list
                .css({
                    position: 'relative'
                });

            if (this.hasInfiniteScrollEnabled()) {
                // https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
                // fix for: https://bugs.chromium.org/p/chromium/issues/detail?id=661155
                //  -> XHR are sometimes blocked while scrolling with the mousewheel
                // note: mousewheel is not a standarised event
                if (window.addEventListener) {
                    window.addEventListener('mousewheel', function (e) {
                        if (e.deltaY === 1)
                            e.preventDefault();
                    });
                }

                this.subscribeEventHandler(this.piping.$actionWrapper, 'scroll', this.checkScrollAndLoadNextPageIfNeeded.bind(this));
            }
            this.$scrollableElement = this.piping.$actionWrapper;
        } else {
            this.$list
                .css({
                    overflowX: this.data.layout === 'Horizontal' ? 'auto' : 'hidden',
                    overflowY: this.data.layout === 'Horizontal' ? 'hidden' : 'auto',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                });

            if (this.hasInfiniteScrollEnabled())
                this.subscribeEventHandler(this.$list, 'scroll', this.checkScrollAndLoadNextPageIfNeeded.bind(this));

            this.subscribeEventHandler(this.$list, 'scroll', function () {
                self.allowSwipe = false;
                if (self.preventScrollEvent) {
                    self.preventScrollEvent = false; // reset flag
                } else {
                    self.scrolledByUser = true;
                }
            });

            this.subscribeEventHandler(this.$list, 'touchend mouseup', function () {
                self.allowSwipe = true;
            });

            this.subscribeEventHandler(this.$list, 'mousedown', function () {
                self.mouseDown = true;
            });

            this.subscribeEventHandler(this.$list, 'mouseup', function () {
                self.mouseDown = false;
            });
        }
    };

    List.prototype.setScrollTop = function (amount) {
        this.preventScrollEvent = true; // set flag
        this.$list.scrollTop(amount);
    };

    List.prototype.deleteItem = function (idToDelete) {
        var existingListItem = _.findWhere(this.pool, {
            id: idToDelete
        });
        if (existingListItem) {
            existingListItem.piping.cleanUp();
            existingListItem.unsubscribeEventHandlersRecursive();
            existingListItem.$element.remove();
            this.removeDrop(existingListItem);
        }
    };

    List.prototype.applyRelativePositioning = function () {
        this.data.autoHeight = true;
    };

    function preventDefault(e) {
        e.preventDefault();
    }

    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            get: function () { supportsPassive = true; }
        }));
    } catch (e) { }

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    List.prototype.disableScroll = function () {
        window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    };

    List.prototype.enableScroll = function () {
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
        window.removeEventListener('touchmove', preventDefault, wheelOpt);
    };

    List.prototype.applyPositionForChild = function (childDrop) {
        var offset = this.getItemOffset();
        var size = this.getItemSize();

        var childCss = {
            position: 'relative'
        };

        if (this.data.layout === 'Dynamic Vertical') {
            childCss['height'] = 'auto';
            childCss['width'] = 'auto';
            childCss['minHeight'] = size.y + 'px';
            childCss['marginTop'] = offset.y + 'px';
            childCss['marginLeft'] = offset.x + 'px';
            childCss['marginRight'] = offset.x + 'px';
        } else {
            if (!this.data.reverseScrolling)
                childCss[this.data.verAlignDirection === 'Top' ? 'marginTop' : 'marginBottom'] = offset.y + 'px';
            else
                childCss[this.data.verAlignDirection === 'Top' ? 'marginBottom' : 'marginTop'] = offset.y + 'px';
            childCss['height'] = size.y + 'px';

            if (childDrop.data.left !== null && childDrop.data.left !== undefined
                && childDrop.data.right !== null && childDrop.data.right !== undefined) {
                childCss['display'] = 'block';
                childCss['marginLeft'] = childDrop.data.left + 'px';
                childCss['marginRight'] = childDrop.data.right + 'px';
            } else {
                childCss['display'] = this.data.layout === 'Vertical' ? 'block' : 'inline-block';
                childCss[this.data.horAlignDirection === 'Left' ? 'marginLeft' : 'marginRight'] = offset.x + 'px';
                childCss['width'] = size.x + 'px';
            }
        }

        // In a special case the first/last list item does not have left/right margin
        if (this.data.layout === 'Horizontal' &&
            this.data.listItemAlignment === 'center') {
            if (childDrop.data.isFirst) {
                childCss['marginLeft'] = '';
            } else if (childDrop.data.isLast) {
                childCss['marginRight'] = '';
            }
        }

        childDrop.$element.css(childCss);
    };

    List.prototype.setData = function (data, isUpdate) {
        var self = this;

        if (isUpdate) {
            this.scrollTop = this.$scrollableElement.scrollTop();
            this.scrollLeft = this.$scrollableElement.scrollLeft();

            this.newItems++;

            if (self.newItems === self.data.pageSize) {
                self.loadedPagesForward++;
                self.newItems = 0;
            }

            var groupedData = this.groupData(data);
            this.groupingLoss += data.results.length - groupedData.results.length;
            this.renderData(data, groupedData, false, isUpdate);
        } else {
            if (!self.rendered || self.rendering) {
                self.queuedData = data;
            } else {
                return self.update(data);
            }
        }
    };

    List.prototype.postRender = function () {
        this.rendered = true;

        if (this.data.mockData && !this.queuedData && !this.data.dataSource) {
            var lines = this.data.mockData.split('\n');

            if (lines.length > 1) {
                var outputs = _.map(lines.shift().split(','), function (value) {
                    return value.trim();
                });

                var rows = _.map(lines, function (line) {
                    return _.map(line.split(','), function (value) {
                        return value.trim();
                    });
                });

                var data = {

                    outputs: _.object(_.map(outputs, function (output) {
                        return [output, 'System.String'];
                    })),

                    results: _.map(rows, function (row) {
                        return _.object(_.map(row, function (value, i) {
                            return [outputs[i] || value, value];
                        }));
                    }),

                    totalResults: rows.length

                };
                this.setData(data);
            }
        }
        this.renderLoadingItem();
        return this.renderQueuedData();
    };

    List.prototype.renderQueuedData = function () {
        if (this.queuedData) {
            var result = this.update(this.queuedData);
            this.queuedData = null;
            return result;
        }
    };

    List.prototype.focus = function () {
        this.$list.trigger('focus');
    };

    List.prototype.initializeTemplates = function () {
        var self = this;

        // unfortunately, there are three versions of child morph data structure:
        // v1: morphs[0] is itemtemplate, rest are headers, no discriminator field
        // v2: morphs[0] is itemtemplate, rest are headers plus with discriminator: nextPage and preloader templates
        // v3: all child morphs have discriminator (item, header, nextPage, preloader)
        // all versions need to be parsed correctly
        // headers are not mandatory

        _.chain(self.childDrops)
            .filter(function (childModel) {
                return childModel.data.itemTemplateType === undefined;
            });

        self.itemTemplatesData = _.filter(self.childDrops, function (childModel) {
            return childModel.data.itemTemplateType === 'item';
        });

        if (self.itemTemplatesData.length === 0) {
            self.itemTemplatesData = [self.getDefaultItemTemplate()];
        }

        self.headerTemplatesData = _.filter(self.childDrops, function (childModel) {
            return childModel.data.itemTemplateType === 'header';
        });

        self.loadingTemplatesData = _.filter(self.childDrops, function (childModel) {
            return childModel.data.itemTemplateType === 'loading';
        });

        self.swipeTemplatesData = _.filter(self.childDrops, function (childModel) {
            return childModel.data.itemTemplateType === 'rightSwipeItem'
                || childModel.data.itemTemplateType === 'leftSwipeItem';
        });

        self.nextPageTemplateData =
            _.find(self.childDrops, function (childModel) {
                return childModel.data.itemTemplateType === 'nextPage';
            }) || self.getDefaultNextPageTemplate();

        self.preloaderTemplateData =
            _.find(self.childDrops, function (childModel) {
                return childModel.data.itemTemplateType === 'preloader';
            }) || self.getDefaultPreloaderTemplate();

        self.childDrops = self.headerTemplatesData
            .concat(self.loadingTemplatesData)
            .concat(self.itemTemplatesData)
            .concat(self.swipeTemplatesData)
            .concat([
                self.nextPageTemplateData,
                self.preloaderTemplateData
            ]);
    };

    List.prototype.getDefaultItemTemplate = function () {
        if (this.designData && this.designData.hasInitialDynamicText) {
            var dtName = this.designData.cqData && this.designData.cqData.isProcessList ? 'Name' : 'item'
            return {
                data: {
                    type: 'ListItem',
                    itemTemplateType: 'item',
                    position: { x: 5, y: 5 },
                    size: { x: 250, y: 40 },
                    zIndex: 0, color: '#3C3',
                },
                childDrops: [
                    { data: { type: 'DynamicText', name: dtName, size: { x: 200, y: 20 }, position: { x: 10, y: 10 } } },
                ]
            }
        }
        else if (this.designData && this.designData.hasInitialModalAction) {
            return {
                data: {
                    type: 'ListItem',
                    itemTemplateType: 'item',
                    position: { x: 5, y: 5 },
                    size: { x: 250, y: 40 },
                    zIndex: 0, color: '#3C3',
                },
                childDrops: [
                    {
                        data: {
                            type: 'Stack',
                            size: { x: 280, y: 20 },
                            position: { x: 0, y: 0 }
                        },
                        childDrops: [
                            {
                                data: {
                                    name: 'modalWidget',
                                    type: 'ModalAction',
                                    size: { x: 280, y: 80 },
                                    position: { x: 0, y: 0 },
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    actionSource: 'fromParameter',
                                    actionIdParameter: 'ActionId',
                                    parameters: ['PageWidgetId'],
                                    eventsToCatch: ['GoToProcess']
                                },
                                childDrops: []
                            }
                        ]
                    },
                ]
            }
        }
        return {
            data: {
                type: 'ListItem',
                itemTemplateType: 'item',
                position: { x: 10, y: 10 },
                size: { x: 100, y: 50 },
                zIndex: 0, color: '#3C3'
            },
            childDrops: []
        };
    };

    List.prototype.getDefaultNextPageTemplate = function () {
        return {
            data: {
                type: 'ListItem',
                itemTemplateType: 'nextPage',
                position: { x: 10, y: 10 },
                size: { x: 100, y: 50 }
            },
            childDrops: [
                { data: { type: 'Button', text: 'Load more', size: { x: 100, y: 25 }, position: { x: 0, y: 0 } } },
                { data: { type: 'DynamicText', name: 'total', size: { x: 65, y: 25 }, position: { x: 0, y: 25 }, styles: { normal: { text: { align: 'right' }, enabled: true } } } },
                { data: { type: 'Text', text: 'total', size: { x: 30, y: 25 }, position: { x: 70, y: 25 } } }
            ]
        };
    };

    List.prototype.getDefaultPreloaderTemplate = function () {
        return {
            data: {
                type: 'ListItem',
                itemTemplateType: 'preloader',
                position: { x: 10, y: 10 },
                size: { x: 100, y: 50 }
            },
            childDrops: [{
                data: { type: 'Image', cdnPath: 'Drops/List/loading.gif', size: { x: 100, y: 25 }, position: { x: 0, y: 0 } }
            }]
        };
    };

    List.prototype.supportsManyToManyData = function () {
        return this.data.selectionMode === 'multiple';
    };

    List.prototype.getValue = function () {
        if (!this.selectedItems) {
            return null;
        }

        if (this.data.selectionMode === 'single') {
            return this.selectedItems.length === 1 ? this.selectedItems[0].id : null;
        }

        return _.pluck(this.selectedItems, 'id');
    };

    List.prototype.setValue = function (update) {
        if (!this.selectedItems || this.rendering) {
            this.afterRendering.push(this.setValue.bind(this, update));
        } else {
            if (!update.value) {
                this.clearValue();
            } else {
                var valueAsArray = $.isArray(update.value) ? update.value : [update.value];

                if (this.data.selectionMode === 'single' && valueAsArray.length > 0)
                    valueAsArray = [valueAsArray[0]];

                this.updateSelection(valueAsArray);
            }
        }
        this.updateRequiredIndicator();
    };

    List.prototype.clearValue = function () {
        if (!this.selectedItems) {
            return;
        }

        var self = this;
        _.each(self.pool, function (listItem) {
            if (_.indexOf(self.selectedItems, listItem) !== -1) {
                self.renderStyleIfEnabled('normal', listItem);
            }
        });
        self.selectedItems = [];
        this.updateRequiredIndicator();
    };

    List.prototype.isValid = function () {
        if (!this.data.required || !this.data.required.isRequired) return true;
        return !!this.selectedItems && this.selectedItems.length >= 1;
    };

    List.prototype.updateSelection = function (selectedIds) {
        var self = this;
        var previouslySelectedItems = this.selectedItems;
        var newlySelectedItems = [];

        _.each(this.pool, function (listItem) {
            if (_.indexOf(selectedIds, listItem.id) !== -1) {
                newlySelectedItems.push(listItem);
                self.renderStyleIfEnabled('selected', listItem);
            } else if (_.indexOf(previouslySelectedItems, listItem) !== -1) {
                self.renderStyleIfEnabled('normal', listItem);
            }
        });

        this.selectedItems = newlySelectedItems;
    };

    var valueOrDefault = function (value, defaultValue) {
        return value === null || value === undefined ? defaultValue : value;
    };

    List.prototype.getItemOffset = function () {
        return {
            x: valueOrDefault(this.data.childPositionX, this.itemTemplatesData[0].data.position.x),
            y: valueOrDefault(this.data.childPositionY, this.itemTemplatesData[0].data.position.y)
        };
    };

    List.prototype.getItemSize = function () {
        return {
            x: valueOrDefault(this.data.childSizeX, this.itemTemplatesData[0].data.size.x),
            y: valueOrDefault(this.data.childSizeY, this.itemTemplatesData[0].data.size.y)
        };
    };

    List.prototype.clear = function () {
        _.forEach(this.pool, function (drop) {
            if(drop.data.itemTemplateType === 'item') {
                drop.piping.cleanUp();
            }

            drop.unsubscribeEventHandlersRecursive();

        });

        this.$list.empty();
        this.removeAllDrops();
        this.nextPageItem = null;
        this.$alignContainer = null;
    };

    List.prototype.renderLoadingItem = function () {
        var self = this;
        this.updateAlignContainer();
        var loadingDrops = self.piping.dropFactory
            .createDrops(self.loadingTemplatesData, { dynamic: true });

        _.each(loadingDrops, function (loadingDrop) {
            self.addDrop(loadingDrop);
            loadingDrop.render(self.$alignContainer, self.data.reverseScrolling);
        });
    };

    List.prototype.update = function (data) {
        this.clear();
        this.updateAlignContainer();

        if (!data)
            return;

        var self = this;
        self.rendering = true;
        self.selectedItems = [];

        self.resetItemCounters();
        self.totalResults = data.totalResults;
        self.triggerPageOpened(data.totalResults, self.loadedPagesForward - 1, self.data.pageSize);

        if (self.data.infiniteScroll)
            self.loadedAllData = data.totalResults < self.data.pageSize;

        var headerDrops = self.piping.dropFactory
            .createDrops(self.headerTemplatesData, { dynamic: true });

        var listItemsRendered = [];

        _.each(headerDrops, function (headerDrop) {
            self.addDrop(headerDrop);
            self.setTotalData(headerDrop);

            self.setItemCounters(headerDrop);

            new OnLongPress()
                .applyLongPressOnElement(
                    headerDrop.$element,
                    self,
                    headerDrop.defaultEventArg,
                    $.noop,
                    null,
                    self.$list,
                    $.noop
                );

            listItemsRendered.push(headerDrop.render(self.$alignContainer, self.data.reverseScrolling));
            self.incrementItemCounters(headerDrop);
        });

        listItemsRendered.push(self.renderData(data));

        setTimeout(function () {
            var widthOfContainer = self.calcTheWidthOfContainer(self.data.childPositionX, self.data.childSizeX, parseFloat(self.$list.css('width')), self.isListItemSizeDynamic);
            self.$alignContainer
                .css({
                    width: widthOfContainer
                });
            if (self.data.listItemAlignment !== 'left' && self.data.layout === 'Horizontal') {
                _.defer(function () {
                    var scrollPosition = 0;
                    if (self.data.listItemAlignment === 'center') {
                        scrollPosition = (self.$list[0].scrollWidth - self.$list.width()) / 2; // Scroll to center
                    } else if (self.data.listItemAlignment === 'right') {
                        scrollPosition = self.$list[0].scrollWidth - self.$list.width(); // Scroll to right
                    }
                    self.$list.scrollLeft(scrollPosition);
                });
            }
        });

        return when.all(listItemsRendered);
    };

    List.prototype.keepPagingInformation = function () {
        return this.data.pagingEnabled
            && this.data.keepPagerPositionOnQueryReload
            && this.loadedPagesForward !== 0;
    };

    List.prototype.resetItemCounters = function () {
        this.currentRow = 0;
        this.currentColumn = 0;
        this.itemCounter = 0;
        this.groupingLoss = 0;
        this.loadedAllData = false;

        if (!this.keepPagingInformation())
            this.loadedPagesForward = 1;
    };

    List.prototype.incrementItemCounters = function (lastItem) {
        var self = this;
        self.itemCounter++;
    };

    List.prototype.decrementItemCounters = function () {
        var self = this;
        self.itemCounter--;
    };

    var KEY_SEPARATOR = '$';

    var getPreliminaryGroupingKey = function (resultItem, fieldNames) {
        var groupingValues = _.map(fieldNames, function (headerField) { return resultItem[headerField]; });
        return groupingValues.join(KEY_SEPARATOR);
    };

    List.prototype.createDataItemForGroup = function (groupResultItems, originalData) {
        var self = this;
        var groupDataItem = _.pick(_.first(groupResultItems), self.data.groupByColumns); // only include columns that are certain
        groupDataItem.$groupData = {
            results: groupResultItems,
            outputs: originalData.outputs,
            totalResults: groupResultItems.length
        };
        return groupDataItem;
    };

    var stableGroupBy = function (list, getKey) {
        var keyValuePairs = _.map(list, function (item) {
            return {
                key: getKey(item),
                value: item
            };
        });
        var groupsByKey = {};
        var groupsInOrder = [];
        _.each(keyValuePairs, function (kvp) {
            var group = groupsByKey[kvp.key];
            if (!group) {
                group = [];
                groupsByKey[kvp.key] = group;
                groupsInOrder.push(group);
            }
            group.push(kvp.value);
        });
        return groupsInOrder;
    };

    List.prototype.groupData = function (data) {
        var self = this;
        var groupByColumns = self.data.groupByColumns;
        if (!groupByColumns || groupByColumns.length === 0)
            return data;

        var groupedItems = stableGroupBy(data.results, function (resultItem) {
            return getPreliminaryGroupingKey(resultItem, groupByColumns);
        });

        var groupedResults = _.map(groupedItems, function (group) {
            return self.createDataItemForGroup(group, data);
        });

        return {
            totalResults: data.totalResults,
            outputs: _.pick(data.outputs, groupByColumns),
            results: groupedResults
        };
    };

    List.prototype.setItemCounters = function (listItem) {
        var self = this;
        listItem.itemCounter = self.itemCounter;
        listItem.currentRow = self.currentRow;
        listItem.currentColumn = self.currentColumn;
    };

    List.prototype.removeLastListItem = function (item) {
        var self = this;
        self.decrementItemCounters();
        self.removeDrop(item);
        item.$element.remove();
    };

    List.prototype.getLastListItem = function () {
        var self = this;
        for (var i = self.pool.length - 1; i >= 0; i--) {
            if (self.pool[i].data.itemTemplateType === 'item')
                return self.pool[i];
        }
        return null;
    };

    List.prototype.getFirstListItem = function () {
        for (var i = 0; i < this.pool.length; i++) {
            if (this.pool[i].data.itemTemplateType === 'item')
                return this.pool[i];
        }
        return null;
    };

    List.prototype.isGroupingEnabled = function () {
        return this.data.groupByColumns && this.data.groupByColumns.length > 0;
    };

    var groupInBatches = function (data, size) {
        var i = 0, j = 0;
        var currentBatch = [];
        var result = [currentBatch];
        while (i < data.length) {
            if (j === size) {
                j = 0;
                currentBatch = [];
                result.push(currentBatch);
            }
            currentBatch.push(data[i]);
            i++;
            j++;
        }
        return result;
    };

    var RENDER_BATCH_SIZE = 5;

    if (window.location.search.length) {
        var queryParams = util.parseUriQuery(window.location.search.substring(1));
        if (queryParams.listBatchSize) {
            var batchSizeParam = parseInt(queryParams.listBatchSize, 10);
            if (batchSizeParam > 0 && batchSizeParam < 1024)
                RENDER_BATCH_SIZE = batchSizeParam;
        }
    }

    List.prototype.calcTheWidthOfContainer = function (margin, listItemWidth, listWidth, widthIsDynamic) {
        if (widthIsDynamic || (this.data.layout === 'Continuous' && this.data.listItemAutoSize)) {
            if (this.data.listItemAlignment !== 'center') {
                this.$alignContainer
                    .css({
                        float: this.data.listItemAlignment
                    });
                return '';
            } else if (this.data.layout !== "Dynamic Vertical" && this.data.layout !== "Vertical") {
                return 'fit-content';
            }
            return '';
        }

        var retVal;
        var firstChild = this.$element[0].firstChild;
        var childData = this.itemTemplatesData[0].data;
        var hasAnchorLeft = childData.left !== null && childData.left !== undefined;
        var hasAnchorRight = childData.right !== null && childData.right !== undefined;
        if (hasAnchorLeft || hasAnchorRight) {
            var hasScrollBar = firstChild.clientHeight < firstChild.scrollHeight;
            if (hasScrollBar) {
                var scrollbarWidth =
                    firstChild.offsetWidth -
                    firstChild.clientWidth -
                    parseInt($(firstChild).css('border-left-width')) -
                    parseInt($(firstChild).css('border-right-width'));
                retVal = this.$element[0].getBoundingClientRect().width - scrollbarWidth;
            } else {
                retVal = this.$element[0].getBoundingClientRect().width;
            }
        } else {

            var width;

            if (this.data.listItemAlignment === 'left') {
                width = margin + listItemWidth;
            } else {
                width = 2 * margin + listItemWidth;
            }

            var countOfVisibleData = this.renderedItemsCount;

            if (this.data.layout === 'Horizontal') {
                var i = 0;
                while (i < countOfVisibleData - 1) {
                    width = width + margin + listItemWidth;
                    i++;
                }
                // In a special case the first/last list item does not have left/right margin
                retVal = this.data.listItemAlignment === 'center' ? (width - 2 * margin) : width;
            } else if (this.data.layout === 'Continuous') {
                if (countOfVisibleData !== this.itemCounter) {
                    countOfVisibleData = this.itemCounter;
                }
                var i = 0;
                while (width + margin + listItemWidth <= listWidth && i < countOfVisibleData - 1) {
                    width = width + margin + listItemWidth;
                    i++;
                }
                if (this.isNextPageLinkNeeded() && this.nextPageItem) {
                    width += this.nextPageItem.$element.outerWidth(true);
                }
                retVal = width;
            } else if (this.data.layout === 'Dynamic Vertical' || this.data.layout === 'Vertical') {
                countOfVisibleData += this.itemCounter;
                retVal = '';
                var hasScrollBar = firstChild.clientHeight < firstChild.scrollHeight;
                var scrollbarWidth = hasScrollBar ?
                    firstChild.offsetWidth -
                    firstChild.clientWidth -
                    parseInt($(firstChild).css('border-left-width')) -
                    parseInt($(firstChild).css('border-right-width'))
                    : 0;

                var elementWidth = this.$element[0].getBoundingClientRect().width;

                if (elementWidth === 0) {
                    elementWidth = this.$element.outerWidth();
                }

                retVal = elementWidth - scrollbarWidth;
            }
        }
        return parseFloat(retVal);
    };



    List.prototype.updateAlignContainer = function () {
        if (!this.$alignContainer) {
            this.$alignContainer = $('<div/>')
                .appendTo(this.$list);

            if (this.data.enableSorting) {
                dropSortable.setUpSortable({
                    drop: this,
                    $element: this.$alignContainer,
                    moveable: '.sortable-list-item',
                    ghostClass: 'drag-ghost',
                    forceFallback: this.data.useCustomDragPreview,
                    handle: this.data.handlerDropName ? '.sortable-list-handler' : null,
                    animation: this.data.animationTime,
                    scrolling: this.data.enableScrollingWithSorting ? this.$list[0] : false,
                    scrollSensitivity: this.data.scrollSensitivity, // px, how near the mouse must be to an edge to start scrolling.
                    scrollSpeed: this.data.scrollSpeed
                });
            }
        }

        this.setTheAlignContWidthAndMargins();
    };

    List.prototype.updateAlignContainerResize = function () {
        if (!this.$alignContainer) {
            return;
        }
        this.setTheAlignContWidthAndMargins();
    };

    List.prototype.setTheAlignContWidthAndMargins = function () {
        var self = this;
        setTimeout(function () {
            var widthOfContainer = self.calcTheWidthOfContainer(self.data.childPositionX, self.data.childSizeX, parseFloat(self.$list.css('width')), self.isListItemSizeDynamic);

            if (self.data.listItemAlignment === 'left') {
                self.$alignContainer
                    .css({
                        width: widthOfContainer,
                        marginRight: 'auto'
                    });
            } else if (self.data.listItemAlignment === 'center') {
                self.$alignContainer
                    .css({
                        width: widthOfContainer,
                        margin: '0 auto'
                    });
            } else if (self.data.listItemAlignment === 'right') {
                self.$alignContainer
                    .css({
                        width: widthOfContainer,
                        marginLeft: 'auto'
                    });
            }
        });
    };

    List.prototype.renderData = function (data, groupedData, scrollingQuery, isUpdate) {
        if (!this.parent) return; // received a result from the server but the List was probably already removed from the scree

        var self = this;

        self.updateAlignContainer();

        // "-webkit-overflow-scrolling: touch" doesn't like it when you dynamically add content
        self.$element.removeClass('momentum-scrolling');

        self.rendering = true;

        groupedData = groupedData || self.groupData(data);
        self.totalResults = groupedData.totalResults;

        var keyColumn = self.data.keyColumn || 'Id';

        var lastPreviousItem = self.getLastListItem();
        var lastPreviousData = lastPreviousItem && lastPreviousItem.getData();
        var firstNextData = _.first(groupedData.results);

        if (self.isGroupingEnabled() && lastPreviousData && firstNextData && _.isEqual(
            _.pick(lastPreviousData, self.data.groupByColumns),
            _.pick(firstNextData, self.data.groupByColumns))) {
            firstNextData.$groupData.results = lastPreviousData.$groupData.results.concat(firstNextData.$groupData.results);
            self.removeLastListItem(lastPreviousItem);
        }

        var outputs = groupedData.outputs;
        var results = groupedData.results;

        if (data.state) {
            this.startPage = data.state.startPage;
            this.loadedPagesForward = data.state.endPage - data.state.startPage
        } else {
            this.startPage = this.startPage ?? 0;
        }

        if (self.data.useParentGroupData && self.data.skipItemsWithEmptyId) {
            results = _.filter(results, function (result) {
                return result[keyColumn] !== undefined && result[keyColumn] !== null;
            });
        } else if (self.data.isParentIdEnabled) {
            results = _.filter(results, function (result) {
                return self.piping.idOfItem === result[self.data.parentIdOutput];
            });
        }

        if (!self.data.reverseScrolling && self.loadBackward) {
            results = results.reverse();
        }

        _.each(results, function (currentResult) {
            var existingListItem = _.findWhere(self.pool, {
                id: currentResult[keyColumn]
            });
            if (existingListItem) {
                existingListItem.setData(outputs, currentResult);
                existingListItem.reapplyData();

                results = _.filter(results, function (r) {
                    return r !== currentResult;
                });
            }
        });

        return when.map(results, function (dataRow) {
            var pipingData = self.piping.fork(dataRow, self, self.data.keyColumn);

            if (self.itemTemplatesData.length > 1) {
                return when.reduce(self.itemTemplatesData, function (currentResult, value, index) {
                    if (currentResult) return currentResult;

                    if (jQuery.isEmptyObject(value.data.condition)) {
                        return util.cloneData(value);
                    }

                    var evaluator = pipingData.conditions.getConditionEvaluator(value.data.condition);

                    return evaluator
                        .evaluate(pipingData, true, {
                            [self.data.dataSource]: dataRow,
                        })
                        .then(function (executionData) {
                            if (executionData.conditionResult) {
                                return util.cloneData(value);
                            }
                        });
                }, null);
            } else {
                return util.cloneData(self.itemTemplatesData[0]);
            }
        }).then(function (clonedItemDataToCreate) {
            self.renderedItemsCount = 0;

            _.each(clonedItemDataToCreate, function (morph) {
                morph.rootDrop = self.rootDrop
            });
            var listItemDrops = self.piping.dropFactory
                .createDrops(clonedItemDataToCreate, { dynamic: true });
            var listItemsBatched = groupInBatches(listItemDrops, RENDER_BATCH_SIZE);
            return when.reduce(listItemsBatched, function (_previous, currentBatch, batchIndex) {
                var batchRenderPromises = [];
                _.each(currentBatch, function (listItem, indexWithinBatch) {
                    var index = batchIndex * RENDER_BATCH_SIZE + indexWithinBatch;
                    if (index === 0) {
                        listItem.data.isFirst = true;
                    } else if (index + 1 === results.length) {
                        listItem.data.isLast = true;
                    }
                    if (index > 0)
                        self.incrementItemCounters(listItemDrops[index - 1]);

                    self.addDrop(listItem);

                    var dataRow = results[index];

                    listItem.id = dataRow[keyColumn];
                    listItem.piping = self.piping.fork(dataRow, self, self.data.keyColumn);
                    listItem.defaultEventArg = dataRow[self.data.eventArg];
                    listItem.setData(outputs, dataRow);
                    if (self.data.enableSorting) {
                        listItem.$element.data('id', dataRow[self.data.eventArg]);
                        if (listItem.data.itemTemplateType === 'item') {
                            listItem.$element.addClass('sortable-list-item');
                        }
                    }
                    listItem.$element.css('overflow', '');
                    listItem.$element.css('vertical-align', 'top');

                    if (!self.data.isParentIdEnabled || self.piping.idOfItem === dataRow[self.data.parentIdOutput]) {
                        self.setItemCounters(listItem);
                        batchRenderPromises.push(listItem.render(self.$alignContainer, self.data.reverseScrolling || self.loadBackward, isUpdate));
                        self.renderedItemsCount++;
                    }
                });
                return when.all(batchRenderPromises).then(function () {
                    if (self.data.reverseScrolling && self.oldScrollHeight
                        && scrollingQuery && (self.data.onlyLoadFirstPage || self.hasInfiniteScrollEnabled())) {
                        var scrollHeight = self.$list.prop('scrollHeight');
                        self.setScrollTop(scrollHeight - self.oldScrollHeight);
                    }

                    if (self.loadBackward) {
                        if (self.data.layout === "Horizontal") {
                            var scrollWidth = self.$list.prop('scrollWidth');
                            self.$scrollableElement.scrollLeft(scrollWidth - self.oldScrollWidth);
                        } else {
                            var scrollHeight = self.$list.prop('scrollHeight');
                            self.$scrollableElement.scrollTop(scrollHeight - self.oldScrollHeight);
                        }
                    }
                });
            }, null)
                .yield(listItemDrops)
                .then(function (listItemDrops) {
                    if (listItemDrops.length > 0) {
                        self.incrementItemCounters(listItemDrops[listItemDrops.length - 1]);
                        if (listItemDrops[0].childDrops.length === 1 && listItemDrops[0].childDrops[0].data.type === 'Stack') {
                            self.isListItemSizeDynamic = true;
                        } else if (listItemDrops[0].childDrops.length === 1 && listItemDrops[0].childDrops[0].data.type === 'DynamicGridLayout' && (listItemDrops[0].childDrops[0].data.useDynamicWidth || listItemDrops[0].childDrops[0].data.useDynamicHeight)) {
                            self.isListItemHasDynGrid = true;
                        }
                        self.setWidthOfListItems();
                    }
                    _.each(listItemDrops, function (listItem, index) {
                        if (self.isListItemSizeDynamic) {
                            listItem.$element
                                .css({
                                    overflow: 'hidden'
                                });
                        }
                        if (self.data.layout === 'Vertical' && self.swipeTemplatesData.length > 0) {
                            var swipeItems = [];
                            for (var i = 0; i < self.swipeTemplatesData.length; i++) {
                                swipeItems.push(self.piping.dropFactory.createDrop(self.swipeTemplatesData[i]));
                            }

                            var $wrapper = $('<div class = "swipe-wrapper">');
                            var $div = $('<div class = "swipe-container">');

                            _.each(positioningProps, function (prop) {
                                $wrapper.css(prop, listItem.$element.css(prop || ''));
                            });

                            $wrapper.css({ position: 'relative' });
                            $div.
                                css({
                                    overflow: 'hidden',
                                    position: '',
                                    height: (listItem.$element.outerHeight() + self.data.childPositionY) + 'px'
                                })
                                .appendTo($wrapper);

                            listItem.$element
                                .css({
                                    position: 'relative',
                                    margin: 0,
                                })
                                .appendTo($div);

                            // swapSwipeItems
                            if (swipeItems.length === 2 && swipeItems[0].data.itemTemplateType.includes("left")) {
                                var temp = swipeItems[1];
                                swipeItems[1] = swipeItems[0];
                                swipeItems[0] = temp;
                            }

                            for (var i = 0; i < swipeItems.length; i++) {
                                var itemTemplateType = swipeItems[i].data.itemTemplateType;
                                if (itemTemplateType.includes("left")) {
                                    self.addDrop(swipeItems[i]);
                                    swipeItems[i].render($div).then(function (val) {
                                        var drop = self.getSwipeItemByType(swipeItems, 'leftSwipeItem', 'left-swipe');
                                        drop.$element.addClass('left-swipe');
                                        var top = swipeItems.length === 1 ? -listItem.$element.outerHeight() + 'px' : -2 * listItem.$element.outerHeight() + 'px';
                                        drop.$element.css({
                                            position: 'relative',
                                            zIndex: 1,
                                            left: -listItem.$element.outerWidth() + 'px',
                                            top: top,
                                            margin: 0,
                                            visibility: 'hidden',
                                            overflow: 'hidden',
                                            height: listItem.$element.outerHeight() + 'px',
                                            width: listItem.$element.outerWidth() + 'px'
                                        });
                                        self.addSwipingToListItem(drop);
                                    });
                                } else if (itemTemplateType.includes("right")) {
                                    self.addDrop(swipeItems[i]);
                                    swipeItems[i].render($div).then(function (val) {
                                        var drop = self.getSwipeItemByType(swipeItems, 'rightSwipeItem', 'right-swipe');
                                        drop.$element.addClass('right-swipe');
                                        drop.$element.css({
                                            position: 'relative',
                                            zIndex: 1,
                                            top: -listItem.$element.outerHeight() + 'px',
                                            left: listItem.$element.outerWidth() + 'px',
                                            margin: 0,
                                            visibility: 'hidden',
                                            overflow: 'hidden',
                                            height: listItem.$element.outerHeight() + 'px',
                                            width: listItem.$element.outerWidth() + 'px'
                                        });
                                        self.addSwipingToListItem(drop);
                                    });
                                }
                                var dataRow = results[index];
                                swipeItems[i].defaultEventArg = dataRow[self.data.eventArg];
                            }

                            if (!self.data.reverseScrolling || self.loadBackward)
                                $wrapper.appendTo(self.$alignContainer);
                            else
                                $wrapper.prependTo(self.$alignContainer);
                            self.addSwipingToListItem(listItem);
                            listItem.$element.addClass('center-swipe');
                        }

                        if (self.getEventDataFor('selected').enabled || self.getEventDataFor('clicked').enabled) {
                            listItem.$element.css({ cursor: 'pointer' });
                        }

                        new OnLongPress()
                            .applyLongPressOnElement(
                                listItem.$element,
                                self,
                                listItem.defaultEventArg,
                                function (e) {
                                    self.handleListItemClick(listItem, e);
                                },
                                null,
                                self.$list,
                                function (e) {
                                    self.handleListItemSelection(listItem, e);
                                }
                            );

                        // Respect Top-Bottom margin even when child is relative
                        if (listItem.data.top !== null && listItem.data.top !== undefined
                            && listItem.data.bottom !== null && listItem.data.bottom !== undefined
                            && (self.isListItemHasDynGrid || self.isListItemSizeDynamic)
                            && self.data.layout === 'Horizontal') {
                            self.$alignContainer.css('height', '100%');
                            listItem.$element.css('height', '100%');
                            listItem.$element.css('margin-top', '');
                            self.$list.css('padding-top', listItem.data.top);
                            self.$list.css('padding-bottom', listItem.data.bottom);
                        }
                    });

                    self.rendering = false;

                    _.each(self.afterRendering, function (callback) {
                        callback();
                    });
                    self.afterRendering = [];

                    self.addNextPageLinkIfNeeded();

                    if (self.hasInfiniteScrollEnabled())
                        self.checkScrollAndLoadNextPageIfNeeded();

                    self.nestingContext.executeDataSources();

                    self.oldScrollHeight = self.$list.prop('scrollHeight')
                        - ((self.data.onlyLoadFirstPage || self.hasInfiniteScrollEnabled()) ? 0 : self.data.childSizeY + self.data.childPositionY);

                    self.oldScrollWidth = self.$list.prop('scrollWidth')
                        - ((self.data.onlyLoadFirstPage || self.hasInfiniteScrollEnabled()) ? 0 : self.data.childSizeX + self.data.childPositionX);
                })
                .then(function () {
                    _.defer(function () {
                        // note: defer() is needed in case the items of this list contain nested lists
                        if (self.loadBackward) {
                            return;
                        }

                        if(self.focusStartPageElement) {

                            var listItem = _.findWhere(self.pool, {
                                id: self.piping.parameters.getValue(self.data.startAtItemIdParameter)
                            });

                            if (listItem) {
                                listItem.$element[0].scrollIntoView({
                                    behavior: "instant",
                                    block: "center",
                                    inline: "center"
                                });

                                self.focusStartPageElement = false;
                            }
                        } else {
                            if (self.loadedPagesForward === 1) {
                                if (self.scrollTop < self.$list[0].scrollHeight && !self.isInAList)
                                    self.$scrollableElement.scrollTop(self.scrollTop);

                                if (self.scrollLeft < self.$list[0].scrollWidth)
                                    self.$scrollableElement.scrollLeft(self.scrollLeft);
                            }

                            if (self.data.reverseScrolling && !scrollingQuery) {
                                self.setScrollTop(self.$list.prop('scrollHeight'));
                            }
                        }
                    });
                    self.$element.addClass('momentum-scrolling');

                    return self.renderQueuedData();
                })
                .catch(function (e) {
                    self.piping.errorHandler.showErrorDialog(e);
                });
        });
    };

    List.prototype.getSwipeItemByType = function (swipeItems, type, typeClass) {
        return _.find(swipeItems, function (item) {
            return item.data.itemTemplateType === type
                && item.$element
                && !item.$element.hasClass(typeClass);
        });
    };

    List.prototype.addSwipingToListItem = function (listItem) {
        listItem.$element.on('touchstart mousedown', null, null, this.handleTouchStart.bind(this));
        listItem.$element.on('touchend mouseup', this.handleTouchEnd.bind(this, listItem));
        listItem.$element.on('touchmove mousemove', this.handleTouchMove.bind(this));
    };

    List.prototype.getTouches = function (evt) {
        return evt.touches ||               // browser API
            evt.originalEvent.touches || // jQuery
            [{ clientX: evt.clientX, clientY: evt.clientY }]; // mouse event
    };

    List.prototype.handleTouchStart = function (evt) {
        var firstTouch = this.getTouches(evt)[0];
        mouseDown = true;
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
        var $evtTarget = $(evt.currentTarget);
        var margin = this.data.childPositionX;
        if (!$evtTarget.hasClass('center-swipe')) {
            if ($evtTarget.hasClass('right-swipe') && parseInt($evtTarget.css('left')) === 0) {
                $($evtTarget.siblings('.center-swipe')[0]).css({ left: -$evtTarget.width() - margin + 'px' });
            } else if (parseInt($evtTarget.css('left')) === 0) {
                $($evtTarget.siblings('.center-swipe')[0]).css({ left: $evtTarget.width() + margin + 'px' });
            }
        }
        evt.stopPropagation();
    };

    List.prototype.resetStayed = function ($centerSwipe) {
        if (this.stayedElements && $centerSwipe[0] !== this.stayedElements.center[0]) {
            var self = this;
            this.stayedElements.center.animate({ left: '0px' });
            var width = this.stayedElements.center.outerWidth();
            var left = this.stayedElements.left;
            var right = this.stayedElements.right;

            left.animate(
                {
                    left: -width + 'px'
                },
                {
                    complete: function () {
                        left.css({ visibility: 'hidden' });
                    }
                }
            );

            right.animate(
                {
                    left: width + 'px'
                },
                {
                    complete: function () {
                        right.css({ visibility: 'hidden' });
                    }
                }
            );
            self.stayedElements = null;
        }
    };

    List.prototype.handleTouchMove = function (evt) {
        var $evtTarget = $(evt.currentTarget);
        var $centerSwipe;
        if (!$evtTarget.hasClass('center-swipe')) {
            $centerSwipe = $($evtTarget.siblings('.center-swipe')[0]);
        } else {
            $centerSwipe = $evtTarget;
        }

        var rElems = $centerSwipe.siblings('.right-swipe');
        var lElems = $centerSwipe.siblings('.left-swipe');
        var width = parseInt($('.swipe-container').css('width'));

        if (mouseDown && this.allowSwipe) {
            this.resetStayed($centerSwipe);

            if (!initialPos) {
                initialPos = $centerSwipe.css('left');
            }

            var xUp;
            var yUp;
            if (evt.touches) {
                xUp = evt.touches[0].clientX;
                yUp = evt.touches[0].clientY;
            } else {
                xUp = evt.clientX;
                yUp = evt.clientY;
            }

            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;

            if (Math.abs(xDiff) > Math.abs(yDiff) || this.alreadySwiping) {/*most significant*/
                var newPosInt = parseInt(initialPos) + (xUp - xDown);
                var newPos = newPosInt + 'px';

                var margin = this.data.childPositionX;

                if ((newPosInt >= 0 && lElems.length > 0) || (newPosInt <= 0 && rElems.length > 0))
                    $centerSwipe.css('left', newPos);
                if (!xDown || !yDown) {
                    return;
                }

                if (newPosInt < 0) {
                    this.disableScroll();
                    this.alreadySwiping = true;
                    /* right swipe */
                    rElems.css({
                        left: (newPosInt) + margin + rElems.outerWidth() + 'px',
                        visibility: ''
                    });
                    lElems.css({
                        visibility: 'hidden'
                    });
                } else if (newPosInt > 0) {
                    this.disableScroll();
                    this.alreadySwiping = true;
                    /* left swipe */
                    lElems.css({
                        left: (newPosInt) - margin - lElems.outerWidth() + 'px',
                        visibility: ''
                    });
                    rElems.css({
                        visibility: 'hidden'
                    });
                }

            }
        }
    };

    List.prototype.handleTouchEnd = function (listItem, evt) {
        this.enableScroll();
        this.alreadySwiping = false;
        this.allowSwipe = true;
        mouseDown = false;
        initialPos = null;
        var $evtTarget = $(evt.currentTarget);
        var $centerSwipe;
        if (!$evtTarget.hasClass('center-swipe')) {
            $centerSwipe = $($evtTarget.siblings('.center-swipe')[0]);
        } else {
            $centerSwipe = $evtTarget;
        }

        var newPos = parseInt($centerSwipe.css('left'));
        var width = parseInt($centerSwipe.outerWidth());

        var stayThreshold = this.data.stayThreshold / 100;
        var eventThreshold = this.data.eventThreshold / 100;

        var rElems = $centerSwipe.siblings('.right-swipe');
        var lElems = $centerSwipe.siblings('.left-swipe');

        var margin = this.data.childPositionX;

        if (Math.abs(newPos) / width >= eventThreshold) {
            if (newPos >= 0) {
                this.triggerEventIfEnabled('swipeRight', listItem.defaultEventArg);
                $centerSwipe.animate({
                    left: width + margin + 'px'
                });
                lElems.animate({
                    left: '0px'
                });
            } else {
                this.triggerEventIfEnabled('swipeLeft', listItem.defaultEventArg);
                $centerSwipe.animate({
                    left: -width - margin + 'px'
                });
                rElems.animate({
                    left: '0px'
                });
            }
        } else if (Math.abs(newPos) / width >= stayThreshold) {
            if (newPos >= 0) {
                $centerSwipe.animate({
                    left: (width * stayThreshold) + margin + 'px'
                });
                lElems.animate({
                    left: (width * stayThreshold) - width + 'px'
                });
            } else {
                $centerSwipe.animate({
                    left: -(width * stayThreshold) - margin + 'px'
                });
                rElems.animate({
                    left: -(width * stayThreshold) + width + 'px'
                });
            }
            this.stayedElements = { center: $centerSwipe, right: rElems, left: lElems };
        } else {
            $centerSwipe.animate({ left: '0px' });
            if (newPos >= 0) {
                lElems.animate(
                    {
                        left: -width + 'px'
                    },
                    {
                        complete: function () {
                            lElems.css({ visibility: 'hidden' });
                        }
                    }
                );
            } else {
                rElems.animate(
                    {
                        left: width + 'px'
                    },
                    {
                        complete: function () {
                            rElems.css({ visibility: 'hidden' });
                        }
                    }
                );
            }
            this.stayedElements = null;
        }
    };

    List.prototype.isNextPageLinkNeeded = function () {
        if (!this.data.pagingEnabled || !this.hasNextPage() || this.data.onlyLoadFirstPage)
            return false;
        else {
            return true;
        }
    };

    List.prototype.addNextPageLinkIfNeeded = function () {
        if (!this.isNextPageLinkNeeded())
            return;

        var widthOfContainer = this.calcTheWidthOfContainer(this.data.childPositionX, this.data.childSizeX, parseFloat(this.$list.css('width')), this.isListItemSizeDynamic);
        this.$alignContainer
            .css({
                width: widthOfContainer
            });

        if (!this.data.infiniteScroll || this.autoLoadLimitReached())
            this.addNextPageLink();
    };

    List.prototype.autoLoadLimitReached = function () {
        return this.data.stopAutoLoadPages > 0 && this.loadedPagesForward % this.data.stopAutoLoadPages === 0;
    };

    List.prototype.setTotalData = function (listItem) {
        var self = this;
        listItem.setData({ total: 'System.Int32' }, { total: self.totalResults });
    };

    List.prototype.addNextPageLink = function () {
        var self = this;

        var nextPageItem = self.piping.dropFactory.createDrop(util.cloneData(self.nextPageTemplateData), { dynamic: true });

        if (self.loading || self.rendering || self.nextPageItem) {
            return;
        }

        self.nextPageItem = nextPageItem;
        self.addDrop(nextPageItem);
        self.setTotalData(nextPageItem);
        self.setItemCounters(nextPageItem);
        nextPageItem.render(self.$alignContainer, self.data.reverseScrolling)
            .then(function () {
                nextPageItem.$element
                    .addClass('list-nextPage-item')
                    .css('cursor', 'pointer')
                    .on('click', function () {
                        self.offsetScrollPosition = self.$list.scrollTop();
                        self.removeDrop(nextPageItem);
                        nextPageItem.$element.remove();
                        self.nextPageItem = null;
                        self.loadNextPage();
                    });
                if (self.reverseScrolling && self.oldScrollHeight && !self.data.onlyLoadFirstPage) {
                    var scrollHeightWithPagingEl = self.$list.prop('scrollHeight')
                        + (self.data.onlyLoadFirstPage ? 0 : self.data.childSizeY + self.data.childPositionY);
                    self.setScrollTop(scrollHeightWithPagingEl - self.oldScrollHeight + self.offsetScrollPosition);
                }
            });
        // don't increment itemCounter, this will be removed
    };

    List.prototype.hasInfiniteScrollEnabled = function () {
        return this.data.pagingEnabled && this.data.infiniteScroll;
    };

    List.prototype.checkScrollAndLoadNextPageIfNeeded = function () {
        if (this.startPage === null || (!this.hasNextPage() && self.canLoadBackward) || !this.rendered || (!this.data.dataSource && this.data.mockData) || !this.piping)
            return;

        if (this.relativePositioned) {
            if (!this.data.reverseScrolling) {
                if (this.data.layout === "Horizontal") return;

                if (this.$scrollableElement.scrollTop() < preloadDistance) {
                    this.loadNextPageBackward();
                    return;
                }

                var bottomMargin = this.data.bottom || 0;
                var documentHeight = this.piping.$actionView.outerHeight();
                var windowHeight = this.piping.$actionWrapper.outerHeight();
                var bottomScrollPosition = documentHeight - windowHeight - this.piping.$actionWrapper.scrollTop();

                if (documentHeight === windowHeight || bottomScrollPosition < preloadDistance + bottomMargin) {
                    this.loadNextPageForward();
                }
            } else {
                if (this.piping.$actionWrapper.scrollTop() === 0) {
                    this.loadNextPageForward();
                    return;
                }

                var maxScrollTop = this.$list[0].scrollHeight - this.$list[0].clientHeight;
                if (maxScrollTop - this.$scrollableElement.scrollTop() < preloadDistance) {
                    this.loadNextPageBackward();
                }
            }
        } else {
            if (!this.data.reverseScrolling) {
                if (this.data.layout === "Horizontal") {
                    if (this.$scrollableElement.scrollLeft() < preloadDistance) {
                        this.loadNextPageBackward();
                        return;
                    }

                    var maxScrollLeft = this.$list[0].scrollWidth - this.$list[0].clientWidth;
                    if (maxScrollLeft - this.$scrollableElement.scrollLeft() < preloadDistance)
                        this.loadNextPageForward();
                } else {
                    var clientHeight = this.$list[0].clientHeight;
                    if (clientHeight === 0) return;

                    var maxScrollTop = this.$list[0].scrollHeight - clientHeight;
                    if (maxScrollTop - this.$scrollableElement.scrollTop() < preloadDistance) {
                        this.loadNextPageForward();
                    } else if (this.data.configureStartPageEnabled && this.$scrollableElement.scrollTop() < preloadDistance) {
                        this.loadNextPageBackward();
                    }
                }
            } else {
                if (this.$list.scrollTop() === 0) {
                    this.loadNextPageForward();
                    return;
                }

                var maxScrollTop = this.$list[0].scrollHeight - this.$list[0].clientHeight;
                if (maxScrollTop - this.$scrollableElement.scrollTop() < preloadDistance) {
                    this.loadNextPageBackward();
                }
            }
        }
    };

    List.prototype.executeQuery = function () {
        var self = this;
        this.piping.queryDispatcher.dispatch(
            this.data.dataSource,
            function (response) {
                _.each(self.getDatasourceListenersWithSameParams(), function (listener) {
                    listener.handler(response);
                });
            },
            function (params) {
                self.decorateQueryParams(params);
            });
    };

    List.prototype.getDatasourceListenersWithSameParams = function () {
        var self = this;
        var myParams = self.piping.queryDispatcher.getDefaultQueryParams();
        self.decorateQueryParams(myParams);
        var allListeners = self.piping.datasources.getDatasourceListenersThatListenFor(self.data.dataSource);

        return _.filter(allListeners, function (listener) {
            var params = self.piping.queryDispatcher.getDefaultQueryParams();
            if (typeof (listener.decorateDataFunc) === "function")
                listener.decorateDataFunc(params);
            return _.isEqual(myParams, params);
        });
    };

    List.prototype.hasNextPage = function () {
        var self = this;
        if (self.data.useParentGroupData)
            return false;
        if (self.data.infiniteScroll)
            return !self.loadedAllData;
        return self.totalResults - self.groupingLoss > self.loadedPagesForward * self.data.pageSize;
    };

    List.prototype.loadNextPage = function () {
        var self = this;
        if (self.loading || self.rendering) {
            return;
        }

        self.loading = true;
        self.renderPreloader();

        if (self.mouseDown) { // scrolling with mouse pointer using the side scrollbar
            setTimeout(function () {
                self.queryNextPage();
            }, 300);
        } else {
            self.queryNextPage();
        }
    };

    List.prototype.loadNextPageForward = function () {
        if (!this.autoLoadLimitReached() && !this.loadedAllData) {
            this.loadBackward = false;
            this.loadNextPage();
        }
    };

    List.prototype.loadNextPageBackward = function () {
        this.canLoadBackward = this.startPage > 0 && this.startPage - this.loadedPagesBackward >= 0;

        if (this.canLoadBackward) {
            this.loadBackward = true;
            this.loadNextPage();
        }
    };

    List.prototype.queryNextPage = function () {
        var self = this;
        self.piping.queryDispatcher.backgroundDispatch(
            self.data.dataSource,
            function (data) {
                var groupedData = self.groupData(data);
                self.groupingLoss += data.results.length - groupedData.results.length;
                self.loadedAllData = data.results.length < self.data.pageSize;
                self.loading = false;
                if (self.loadBackward) {
                    self.loadedPagesBackward++;
                } else {
                    self.loadedPagesForward++;
                }
                self.newItems = 0;
                self.removePreloader();
                self.renderData(data, groupedData, self.scrolledByUser, false);
                self.scrolledByUser = false;
            },
            function (params) {
                if (self.loadBackward) {
                    params.page = self.startPage - self.loadedPagesBackward;
                } else {
                    params.page = self.startPage + self.loadedPagesForward;
                }
                params.pageSize = self.data.pageSize;
                params.doNotExecuteCountQuery = self.data.onlyLoadFirstPage || self.data.infiniteScroll;
            },
            function (error) {
                self.loading = false;
                self.removePreloader();
                self.addNextPageLinkIfNeeded();
            });
    };

    List.prototype.renderPreloader = function () {
        var self = this;
        if (!self.loading || self.preloaderItem) {
            return;
        }

        var preloaderItem = self.piping.dropFactory.createDrop(util.cloneData(self.preloaderTemplateData), { dynamic: true });

        if (!self.loading || self.preloaderItem) {
            return;
        }

        self.preloaderItem = preloaderItem;
        self.addDrop(preloaderItem);
        self.setItemCounters(preloaderItem);
        preloaderItem.render(self.$list, self.data.reverseScrolling);
        // don't increment itemCounter, this will be removed
    };

    List.prototype.removePreloader = function () {
        var self = this;

        if (self.preloaderItem) {
            self.removeDrop(self.preloaderItem);
            self.preloaderItem.$element.remove();
            self.preloaderItem = null;
        }
    };

    List.prototype.handleListItemSelection = function (listItem, e) {
        var self = this;
        if (self.data.selectionMode === 'multiple') {
            // for now we're assuming you always need a left click
            if (e && self.handleLeftClickAsMultiSelect(e)) {
                var indexOfItem = self.selectedItems.indexOf(listItem);
                if (indexOfItem === -1) {
                    self.selectedItems.push(listItem);
                    self.renderStyleIfEnabled('selected', listItem);
                } else {
                    self.selectedItems.splice(indexOfItem, 1);
                    self.renderStyleIfEnabled('normal', listItem);
                }
            }
        } else { // single selection mode
            if (self.selectedItems.indexOf(listItem) === -1) {
                if (self.selectedItems.length === 0) {
                    self.selectedItems.push(listItem);
                } else {
                    var previousSelection = self.selectedItems[0];
                    self.renderStyleIfEnabled('normal', previousSelection);
                    self.selectedItems[0] = listItem;
                }
                self.renderStyleIfEnabled('selected', listItem);
            } else if (self.handleLeftClickAsMultiSelect(e)) {
                self.selectedItems = [];
                self.renderStyleIfEnabled('normal', listItem);
            }
        }
        self.updateRequiredIndicator();
    };

    List.prototype.handleListItemClick = function (listItem, e) {
        var self = this;
        if (self.data.selectionMode === 'multiple') {
            // for now we're assuming you always need a left click
            if (e && self.handleLeftClickAsMultiSelect(e)) {
                var indexOfItem = self.selectedItems.indexOf(listItem);
                if (indexOfItem !== -1) {
                    if (self.selectedItems.length === 1) {
                        self.triggerEventIfEnabled('selected', listItem.defaultEventArg);
                    }
                    self.triggerEventIfEnabled('itemSelected', listItem.defaultEventArg);
                } else {
                    if (self.selectedItems.length === 0) {
                        self.triggerEventIfEnabled('deselected', listItem.defaultEventArg);
                    }
                    self.triggerEventIfEnabled('itemDeselected', listItem.defaultEventArg);
                }
            } else {
                self.triggerEventIfEnabled('clicked', listItem.defaultEventArg);
            }
        } else { // single selection mode
            if (self.selectedItems.length === 1) {
                self.triggerEventIfEnabled('selected', listItem.defaultEventArg);
            } else if (e && self.handleLeftClickAsMultiSelect(e)) {
                self.triggerEventIfEnabled('deselected', listItem.defaultEventArg);
            }
            self.triggerEventIfEnabled('clicked', listItem.defaultEventArg);
        }
    };

    List.prototype.handleLeftClickAsMultiSelect = function (e) {
        if (this.data.selectionBehavior === 'leftclick')
            return true;
        return this.data.selectionBehavior === 'ctrl+leftclick'
            && (e.ctrlKey || e.metaKey);
    };

    List.prototype.renderStyleIfEnabled = function (customState, drop) {
        Style.renderStyles(drop, null, null, null, customState);
    };

    // used when a Pager is linked with this drop
    List.prototype.openPage = function (pageNumber) {
        if (this.loading)
            return;

        this.loading = true;

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (data) {
                self.page = pageNumber;
                self.loadedPagesForward = pageNumber + 1;
                self.totalResults = data.totalResults;
                self.loadedAllData = data.totalResults < self.data.pageSize;
                self.loading = false;

                self.$list.empty().scrollTop(0);
                self.$list.empty().scrollLeft(0);
                self.pool = [];
                self.$alignContainer = null;
                self.nextPageItem = null;

                self.renderData(data, null, true, false);
                self.triggerPageOpened(data.totalResults, self.page, self.data.pageSize);
            },
            function (params) {
                params.page = pageNumber;
                params.pageSize = self.data.pageSize;
                params.doNotExecuteCountQuery = false;
                params.sortParameters = self.sortParameters;
            },
            function () {
                self.loading = false;
                self.addNextPageLinkIfNeeded();
            });
    };

    List.prototype.licquidMethod_selectFirstItem = function () {
        if (this.rendering) {
            this.afterRendering.push(this.licquidMethod_selectFirstItem.bind(this));
        } else {
            var firstItem = this.getFirstListItem();
            if (firstItem)
                this.handleListItemClick(firstItem);
        }
    };

    List.prototype.licquidMethod_jumpToItem = function (args) {
        if (this.rendering) {
            this.afterRendering.push(this.licquidMethod_jumpToItem.bind(this, args));
        } else {
            var listItem = _.findWhere(this.pool, { id: args.itemId });
            if (listItem) {
                var $liElement = listItem.$element;
                var childPos = $liElement.offset();
                var parentPos = this.$scrollableElement.offset();
                var childOffset = {
                    top: childPos.top - parentPos.top + this.$scrollableElement.scrollTop(),
                    left: childPos.left - parentPos.left + this.$scrollableElement.scrollLeft()
                }

                if (this.data.layout === 'Horizontal') {
                    this.$scrollableElement.scrollLeft(childOffset.left);
                } else {
                    this.$scrollableElement.scrollTop(childOffset.top);
                }
            }
        }
    };

    return List;
});

